/** Drops optional tour steps whose DOM target is missing (e.g. inbox off the inbox page). */
export function visibleSteps(steps, root) {
  return steps.filter((step) => {
    if (!step.optional) return true
    if (!step.selector) return true
    return Boolean(root.querySelector(step.selector))
  })
}
